import IconEducator from '@/components/icons/educator.vue'
import IconDualEducator from '@/components/icons/dualEducator.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconPencil from '@/components/icons/pencil.vue'
import IconBase from '@/components/IconBase.vue'
import IconForward from '@/components/icons/arrowForward.vue'
import IconCheck from '@/components/icons/check.vue'
import EducatorForm from '@/components/EducatorForm.vue'
import Globals from '@/assets/scripts/global-functions.js'
import BackButton from '@/components/BackButton.vue'
import NextButton from '@/components/forms/ButtonNext.vue'

export default {
    name: "CoveredIndividuals",
    components: {
        IconBase,
        IconEducator,
        IconDualEducator,
        IconArrowBack,
        IconPencil,
        IconForward,
        IconCheck,
        EducatorForm,
        BackButton,
        NextButton
    },
    data: () => ({
        isdualeducator: false,
        educator_id: 0,
        dialog_educator: false
    }),
    methods: {
        CloseModal() {
            this.dialog_educator = false;
        },
        ValidateSessionData() {
            if(this.$parent.EducatorInsuranceProcess.educator_id !== undefined) {
                this.educator_id = this.$parent.EducatorInsuranceProcess.educator_id;
                document.getElementById("educator" + this.educator_id).classList.add("selected");
            }
        },
        SelectThisItem(_eid) { 
            /*
            var a = document.getElementById("educator" + _eid);
            if(a.className.indexOf("selected") < 0) {
                this.$parent.RemoveClassFrom("selector-item", "selected");
                a.classList.add("selected");
                this.educator_id = _eid;
            }*/
        }, 
        Next() {
            /*
            if(this.educator_id > 0) {
                this.$parent.EducatorInsuranceProcess.educator_id = this.educator_id;
                this.$parent.EducatorInsuranceProcess.issavepaper = this.issavepaper;
                this.$parent.UpdateCurrentStep(11);
                this.$parent.SessionUpdate("EducatorInsuranceProcess");
                this.$parent.GoToPage('AddOnsLegal');
            }
            */
            this.$parent.EducatorNextStep(11,"AddOnsLegal"); 
        },
        DeleteThisEducator(_index) {
            if(event.target.classList.contains("remove")) {
               this.$parent.EducatorInsuranceProcess.Educators.splice(_index, 1);
               this.$parent.SessionUpdate("EducatorInsuranceProcess");
            };
        },
    },
    computed: {
        AllFieldsValid: function() {
            let _isvalid = false;
            if(this.$parent.EducatorInsuranceProcess.Educators != undefined) {
                if(this.$parent.EducatorInsuranceProcess.Educators.length > 0) {
                    _isvalid = true;
                }   
            }
            return _isvalid;
        },
        SetUpperCase(_text) {
            return _text.toUpperCase();
        }
    },
    mounted() {
        this.ValidateSessionData();
        this.$parent.CurrentProcess = "EducatorInsuranceProcess";
    }
}